import React from 'react';
import { StatusSupplierInventoryWarehouseEnum } from '@/main/services/enum/StatusSupplierInventoryWarehouseEnum';
import { useStyles } from './styles';

interface Props {
  status: number;
  name: string;
}

export default function StatusImportPartComponent(props: Props) {
  const classes = useStyles();
  const renderColor = () => {
    switch (props.status) {
      case StatusSupplierInventoryWarehouseEnum.Available:
        return '#00cc66';
      case StatusSupplierInventoryWarehouseEnum.Unavailable:
        return '#ff0000';
      case StatusSupplierInventoryWarehouseEnum.PendingToMap:
        return '#ff9900';
      default:
        return '#00cc66';
    }
  };

  return (
    <div
      className={`d-flex align-items-center justify-content-center ${classes.container}`}
      title={props.name}
      style={{ backgroundColor: renderColor() }}
    >
      <span className={classes.spanContainer}>{props.name}</span>
    </div>
  );
}
